module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.cdf281ef.woff";